// extracted by mini-css-extract-plugin
module.exports = {"root":"FanEngagementSection_root__tEdTc","heading":"FanEngagementSection_heading___RKn_","switch":"FanEngagementSection_switch__kGbPK"};